import React from 'react';

export const WarnIcon = ({ size = 22, color = 'currentColor', strokeWidth = 14 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 256 256"
        aria-hidden="true"
        style={{ flex: `0 0 ${size}px`, marginTop: 1 }}
    >
        <path
            d="M142.41 40.22l87.46 151.87C236 202.79 228.08 216 215.46 216H40.54C27.92 216 20 202.79 26.13 192.09l87.46-151.87c6.3-10.96 22.52-10.96 28.82 0z"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
        />
        <line x1="128" y1="104" x2="128" y2="144" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        <circle cx="128" cy="180" r="9" fill={color} />
    </svg>
);
